import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/rpc-platform/page.tsx");
